import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function useOnPathChange(onPathChanged: () => void) {
    const pathname = usePathname();

    const [lastPath, setLastPath] = useState(pathname);

    useEffect(() => {
        if (lastPath !== pathname) {
            onPathChanged();
            setLastPath(pathname);
        }
    }, [pathname, onPathChanged, lastPath]);
}
